import { render, staticRenderFns } from "./CommissionApplication.vue?vue&type=template&id=48c0c4dc&scoped=true"
import script from "./CommissionApplication.vue?vue&type=script&lang=js"
export * from "./CommissionApplication.vue?vue&type=script&lang=js"
import style0 from "./CommissionApplication.vue?vue&type=style&index=0&id=48c0c4dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c0c4dc",
  null
  
)

export default component.exports